export const isValidForS3 = (linkslug: string) => {
  const rgxASCI = /^(?:(?![^\x00-\x7F]).)+$/; // eslint-disable-line no-control-regex
  // Detect non-words or - or _
  const rgxNonWords = /[^a-zA-Z0-9-_]/;

  return rgxASCI.test(linkslug) ? !rgxNonWords.test(linkslug) : false;
};
